import JSConfetti from 'js-confetti'

export const confetti = () => {

	let el = document.querySelector('[data-animation="confetti"]')

	if (!el) return

	const jsConfetti = new JSConfetti()

	jsConfetti.addConfetti()

}

export default () => { }